import { useEffect, useState } from "react";

const BRANDING_URL =
  (process.env.APP_AUTH_URL || "https://www.sanatandharmmahasabha.com") + "/api/users/branding/current";
const CACHE_KEY = "brandLogo";
const CACHE_TTL_MS = 5 * 60 * 1000;

// Shared across components so the API is called once per page load.
let inflight = null;

const fetchCurrentLogo = () => {
  if (!inflight) {
    inflight = fetch(BRANDING_URL)
      .then((res) => (res.ok ? res.json() : { logoUrl: null }))
      .then((data) => {
        const logoUrl = data?.logoUrl || null;
        localStorage.setItem(CACHE_KEY, JSON.stringify({ logoUrl, at: Date.now() }));
        return logoUrl;
      })
      .catch(() => null)
      .finally(() => {
        setTimeout(() => { inflight = null; }, CACHE_TTL_MS);
      });
  }
  return inflight;
};

const readCache = () => {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
  } catch (_e) {
    return null;
  }
};

const setFavicon = (href) => {
  document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']").forEach((link) => {
    link.href = href;
  });
};

// Returns the temporary (festival) logo when one is scheduled for today,
// otherwise `defaultLogo`. Also swaps the browser tab icon.
export default function useBrandLogo(defaultLogo) {
  const cached = readCache();
  const [logo, setLogo] = useState(cached?.logoUrl || defaultLogo);

  useEffect(() => {
    let active = true;
    const fresh = cached && Date.now() - cached.at < CACHE_TTL_MS;
    const apply = (logoUrl) => {
      if (!active) return;
      setLogo(logoUrl || defaultLogo);
      setFavicon(logoUrl || `${process.env.PUBLIC_URL || ""}/logo.png`);
    };

    if (fresh) apply(cached.logoUrl);
    else fetchCurrentLogo().then(apply);

    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLogo]);

  return logo;
}
